import React, {useState, useContext, useEffect, use} from 'react'
import { AppContext,UserContext } from '../../../AppContextProvider';
import {ButtonLoader} from '../../utils/ButtonLoader';
import { isMobile } from "react-device-detect";
import { useNavigate, useParams } from "react-router-dom";
import {useFetch} from '../../api/FetchApiData';
import { useTranslation } from 'react-i18next';


if (isMobile)
    import('./form_mob.css').then(() => {});
  else
    import('./form.css').then(() => {});

export default function Login({setConFormIsSelected,setUserId=()=>{}})
{
    const [loginData,setLoginData] = useState({'email':"","password":""});
    const [UserState,setUserState] = useContext(UserContext);
    const [loading,setLoading] = useState(false);
    const [AppState,setAppState] = useContext(AppContext);
    const params = useParams();
    const fetchData = useFetch();
    const navigator = useNavigate();
    const [notification,setNotification] = useState("")
    const {t} = useTranslation();
    
    useEffect(()=>{
        if(UserState.auth)
        {navigator('/');}
    },[UserState.auth])

    useEffect(()=>{
        /*
        if(fetchData.error.error === "No active account found with the given credentials")
        {setNotification("Mot de passe ou email incorrect");}
        */
        if(fetchData.error.error === "account_activation_error")
        {
            setNotification("Votre compte n'est pas encore activé. Veuillez vérifier votre email pour activer votre compte.");
            setConFormIsSelected(3);
            setUserId(fetchData.error.user_id);
        }
        else if(!!fetchData.error)
        {setNotification(fetchData.error.error);}
    },[fetchData.error])

    const LoginRequest= async ()=>
    {
        setLoading(true);
        await fetchData.Login(loginData,UserState,setUserState);
        setLoading(false);
    }

    const NewAccount=()=>
    {
        if(!params.hasOwnProperty("result") || !(params.result === 'success' || params.result === 'failed'))
            return <input onClick={e=>{setConFormIsSelected(4);}} type="button" className="btnSubmit" style={{backgroundColor:'lightgray',fontSize:'x-small'}} value={t("authentication.inscription")} />;
    }

    return(
        <div className="Form">
                <p style={{color:'orangered'}}>{notification}</p>
                <form className='form-form'  onSubmit={e=>{e.preventDefault(); LoginRequest();}}>
                    <div className="inputDiv" style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row'}}>
                        <label >{t('authentication.email')}</label>
                        <input onChange={e=>{setLoginData({...loginData,"email":e.target.value})}} defaultValue={loginData.email} type="email" name="email" placeholder={t("authentication.email")} />
                    </div>
                    <div className="inputDiv" style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row'}}>
                        <label>{t('authentication.mot-de-passe')}</label>
                        <input name="password" onChange={e=>{setLoginData({...loginData,"password":e.target.value})}} defaultValue={loginData.password} type="password" placeholder="*************" />
                    </div>
                    <div style={{width:'100%',margin:'auto',marginTop:'10px'}}>
                        <div className="btnSubmit">
                            <ButtonLoader loading={loading} onSubmit={e=>{LoginRequest()}} style={{backGroundColor:'yellowgreen',fontSize:'x-small'}}  text={t("authentication.envoyer")} />
                        </div>
                        {NewAccount()}
                        <div id="fpassword" >
                            <input onClick={e=>{setConFormIsSelected(2);}} type="button" className="btnSubmit" style={{backgroundColor:'transparent',color:'blue'}} value={t("authentication.mot-de-passe-oublie")}></input>
                        </div>
                    </div>
                </form>
        </div>
    );
}

